<template>
  <div id="about">
    <section class="section about-section">
      <Container>
        <div class="about-intro">
          <div class="about-intro-text" data-reveal>
            <p class="eyebrow">Who We Are</p>
            <h2>About Deyoke Foods</h2>
            <p class="lead">{{ aboutList[0].body }}</p>
          </div>
          <div class="about-intro-image" data-reveal>
            <img src="@/assets/IMG_0238.jpg" alt="Deyoke Foods turkey berry harvest" />
            <div class="image-frame"></div>
          </div>
        </div>

        <div class="mvv-grid">
          <AboutComponent
            v-for="(item, index) in aboutList.slice(1)"
            :key="index"
            :index="index"
            :title="item.title"
            :body="item.body"
          />
        </div>
      </Container>
    </section>

    <Aims />
  </div>
</template>

<script setup>
import { reactive } from "vue";
import Container from "@/components/Container/Container.vue";
import AboutComponent from "./AboutComponent/AboutComponent.vue";
import Aims from "./Aims/Aims.vue";

const aboutList = reactive([
  {
    title: "ABOUT US",
    body: "Deyoke Foods is an innovator in turkey berry powder and tea, transforming this sector and elevating these super foods to new heights. We deliver premium organic and high-quality turkey berry powder and tea crafted in different flavors, perfectly suited for domestic and industrial purposes such as pharmaceuticals, cosmetics, culinary uses, traditional medicines, and everyone who needs a natural energy and immune booster for a healthy lifestyle.",
  },
  {
    title: "Our Mission",
    body: "Deyoke Foods' mission is to empower individuals to lead healthier lives by providing high-quality, nutritious turkey berry powder and tea. We are committed to sustainable practices that support local communities and the environment, while educating consumers about the benefits of our products.",
  },
  {
    title: "Our Vision",
    body: "We envision a world where nutritious, natural products enhance everyday wellness. By specializing in turkey berry, we aim to promote holistic health and sustainable living — sourcing high-quality ingredients, maintaining eco-friendly practices, and empowering communities through education.",
  },
]);
</script>

<style scoped>
.about-intro {
  display: grid;
  grid-template-columns: 1fr 0.9fr;
  align-items: center;
  gap: 4rem;
}

.about-intro-text h2 {
  font-size: clamp(1.9rem, 3.2vw, 2.5rem);
  font-weight: 700;
}

.about-intro-text .lead {
  margin-top: 1.15rem;
  font-size: 1.02rem;
  line-height: 1.8;
  color: var(--body-text);
}

.about-intro-image {
  position: relative;
}

.about-intro-image img {
  width: 100%;
  height: 380px;
  object-fit: cover;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.image-frame {
  position: absolute;
  inset: -16px -16px auto auto;
  width: 55%;
  height: 55%;
  border: 3px solid var(--accent);
  border-radius: var(--radius-lg);
  z-index: -1;
}

.mvv-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-top: 4.5rem;
}

@media (max-width: 1023px) {
  .about-intro {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .about-intro-image {
    order: -1;
  }

  .about-intro-image img {
    height: 320px;
  }

  .mvv-grid {
    margin-top: 3rem;
  }
}

@media (max-width: 640px) {
  .mvv-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
